
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, X } from "lucide-react";
import { STORAGE_URL } from "@/lib/supabase";
import { KitLogoLink } from "./types";

interface CurrentLogoProps {
  isLoading: boolean;
  kitLogo: KitLogoLink | null;
  onRemove: () => void;
}

export const CurrentLogo: React.FC<CurrentLogoProps> = ({
  isLoading,
  kitLogo,
  onRemove,
}) => {
  return (
    <div className="border border-white/10 bg-black h-[100px] rounded-md flex items-center justify-center overflow-hidden">
      {isLoading ? (
        <Loader2 className="h-6 w-6 animate-spin text-white/70" />
      ) : kitLogo?.logo?.storage_path ? (
        <div className="relative h-full w-full">
          <img 
            src={`${STORAGE_URL}/storage/v1/object/public/logos/${kitLogo.logo.storage_path}`}
            alt="Current logo" 
            className="h-full w-full object-contain p-2"
          />
          <Button 
            size="icon" 
            variant="destructive" 
            className="absolute top-1 right-1 h-6 w-6 rounded-full"
            onClick={onRemove}
          >
            <X className="h-3 w-3" />
          </Button>
        </div>
      ) : (
        <span className="text-white/50">No logo selected</span>
      )}
    </div>
  );
};
